module.exports = __webpack_public_path__ + "assets/img/tsgn6.352e247d.png";